import { render } from "./LocationLoader.vue?vue&type=template&id=4a514544"
import script from "./LocationLoader.vue?vue&type=script&lang=js"
export * from "./LocationLoader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__